import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-30e68450"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Accede a tu cuenta para activar la botonera de seguimiento de lecciones.", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "inner-btns"
}
const _hoisted_5 = { class: "play-bar-container" }
const _hoisted_6 = {
  class: "play-btn",
  style: {"width":"100%","border":"0","text-decoration":"none","overflow":"hidden"}
}
const _hoisted_7 = {
  key: 1,
  class: "play-btn",
  style: {"width":"100%","border":"0","text-decoration":"none","overflow":"hidden"}
}


import { onMounted, ref } from 'vue'
import { useAuth } from '@/store/useAuth'
import CompletedService from '@/services/CompletedService'
import LaterService from '@/services/LaterService'
import FavService from '@/services/FavService'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface'
import LessonService from '@/services/LessonService'


export default /*#__PURE__*/_defineComponent({
  __name: 'LessonBtns',
  props: ['lessonId'],
  emits: ['refreshStatus', 'showNotes', 'showDescription', 'showLessonDescription', 'showSummary', 'goPrev', 'goNext'],
  setup(__props, { emit: __emit }) {

const store = useAuth()
const completedService = new CompletedService()
const laterService = new LaterService()
const favService = new FavService()
const props = __props
const emit = __emit
const completedLoading = ref(true)
const favLoading = ref(true)
const laterLoading = ref(true)
const isFav = ref()
const isCompleted = ref()
const isLater = ref()
const toast = useToast()
const lesson = ref()
const lessonService = new LessonService()

onMounted(async () => {
    completedLoading.value = true
    favLoading.value = true
    laterLoading.value = true

    if (!store.token) {
        completedLoading.value = false
        favLoading.value = false
        laterLoading.value = false
        return
    }
    lesson.value = await lessonService.getLesson(props.lessonId)
    isFav.value = await favService.checkFavStatus(store.token, props.lessonId)
    isCompleted.value = await completedService.checkCompletedStatus(store.token, props.lessonId)
    isLater.value = await laterService.checkLaterStatus(store.token, props.lessonId)

    completedLoading.value = false
    favLoading.value = false
    laterLoading.value = false
})

const handleDoCompleted = async () => {
    if (!store.token) {
        return
    }
    completedLoading.value = true
    await completedService.doCompleted(store.token, props.lessonId)
    isCompleted.value = true
    toast.showToast("Marcado como completado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    emit("refreshStatus")
    completedLoading.value = false
}
const handleDoFav = async () => {
    if (!store.token) {
        return
    }
    favLoading.value = true
    await favService.doFav(store.token, props.lessonId)
    isFav.value = true
    toast.showToast("Marcado como favorito.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    favLoading.value = false
}
const handleDoLater = async () => {
    if (!store.token) {
        return
    }
    laterLoading.value = true
    await laterService.doLater(store.token, props.lessonId)
    isLater.value = true
    toast.showToast("Añadido a ver más tarde.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    laterLoading.value = false
}
const handleDoNoCompleted = async () => {
    if (!store.token) {
        return
    }
    completedLoading.value = true
    await completedService.doNoCompleted(store.token, props.lessonId)
    isCompleted.value = false
    toast.showToast("Marcado como NO completado.", Toast.WARNING)
    setTimeout(function () { toast.hideToast() }, 4000);
    emit("refreshStatus")
    completedLoading.value = false
}
const handleDoNoFav = async () => {
    if (!store.token) {
        return
    }
    favLoading.value = true
    await favService.doNoFav(store.token, props.lessonId)
    isFav.value = false
    toast.showToast("Eliminado de favoritos.", Toast.WARNING)
    setTimeout(function () { toast.hideToast() }, 4000);
    favLoading.value = false
}
const handleDoNoLater = async () => {
    if (!store.token) {
        return
    }
    laterLoading.value = true
    const response = await laterService.doNoLater(store.token, props.lessonId)
    isLater.value = false
    toast.showToast("Eliminado de ver más tarde.", Toast.WARNING)
    setTimeout(function () { toast.hideToast() }, 4000);
    laterLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(store).token)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "play-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('goPrev')))
            }, [
              _createVNode(_component_v_icon, {
                class: "play-icon",
                name: "bi-arrow-left-circle-fill",
                scale: "2",
                title: "Anterior"
              }),
              _createTextVNode(" Anterior")
            ]),
            _createElementVNode("button", {
              class: "play-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('showDescription')))
            }, [
              _createVNode(_component_v_icon, {
                class: "play-icon",
                name: "md-summarize",
                scale: "2",
                title: "Descripción del curso"
              }),
              _createTextVNode(" Sobre el curso")
            ]),
            _createElementVNode("button", {
              class: "play-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('showLessonDescription')))
            }, [
              _createVNode(_component_v_icon, {
                class: "play-icon",
                name: "md-description",
                scale: "2",
                title: "Descripción de la clase"
              }),
              _createTextVNode(" Descripción")
            ]),
            _createElementVNode("button", {
              class: "play-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('showNotes')))
            }, [
              _createVNode(_component_v_icon, {
                class: "play-icon",
                name: "bi-pencil-fill",
                scale: "2",
                title: "Tomar y leer mis apuntes"
              }),
              _createTextVNode(" Mis apuntes")
            ]),
            _createElementVNode("button", {
              class: "play-btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('showSummary')))
            }, [
              _createVNode(_component_v_icon, {
                class: "play-icon",
                name: "io-list-circle-sharp",
                scale: "2",
                title: "Ver y navegar por el temario"
              }),
              _createTextVNode(" Temario")
            ]),
            (lesson.value)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  class: "play-btn inner-btn",
                  target: "_blank",
                  style: {"margin":"0","padding":"0","cursor":"pointer","text-decoration":"none"},
                  to: { name: 'detail-question-course', params: { course_id: lesson.value.course_id, lesson_id: lesson.value.id } }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_6, [
                      _createVNode(_component_v_icon, {
                        class: "play-icon",
                        name: "bi-question-circle-fill",
                        scale: "2",
                        title: "Dudas y preguntas"
                      }),
                      _createTextVNode(" Dudas")
                    ])
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock("button", _hoisted_7, [
                  _createVNode(_component_v_icon, {
                    class: "play-icon",
                    name: "ri-loader-2-fill",
                    animation: "spin",
                    scale: "2",
                    title: "Dudas y preguntas"
                  }),
                  _createTextVNode(" Dudas")
                ])),
            (!isFav.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "play-btn",
                  onClick: handleDoFav
                }, [
                  (favLoading.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "play-icon",
                        name: "ri-loader-2-fill",
                        animation: "spin",
                        scale: "2",
                        title: "Añadir a favoritos"
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        class: "play-icon",
                        name: "bi-heart",
                        scale: "2",
                        title: "Añadir a favoritos"
                      })),
                  _createTextVNode(" Favorito ")
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "play-btn play-btn-selected",
                  onClick: handleDoNoFav
                }, [
                  (favLoading.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "play-icon",
                        name: "ri-loader-2-fill",
                        animation: "spin",
                        scale: "2",
                        title: "Añadir a favoritos"
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        class: "play-icon",
                        name: "bi-heart-fill",
                        scale: "2",
                        title: "Eliminar de favoritos"
                      })),
                  _createTextVNode(" Favorito ")
                ])),
            (!isLater.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  class: "play-btn",
                  onClick: handleDoLater
                }, [
                  (laterLoading.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "play-icon",
                        name: "ri-loader-2-fill",
                        scale: "2",
                        animation: "spin",
                        title: "Ver más tarde"
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        class: "play-icon",
                        name: "md-watchlater-outlined",
                        scale: "2",
                        title: "Ver más tarde"
                      })),
                  _createTextVNode(" Ver más tarde ")
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  class: "play-btn play-btn-selected",
                  onClick: handleDoNoLater
                }, [
                  (laterLoading.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "play-icon",
                        name: "ri-loader-2-fill",
                        scale: "2",
                        animation: "spin",
                        title: "Ver más tarde"
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        class: "play-icon",
                        name: "md-watchlater-outlined",
                        scale: "2",
                        title: "Eliminar de ver más tarde"
                      })),
                  _createTextVNode(" Ver más tarde ")
                ])),
            (!isCompleted.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 6,
                  onClick: handleDoCompleted,
                  class: "play-btn"
                }, [
                  (completedLoading.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "play-icon",
                        name: "ri-loader-2-fill",
                        scale: "2",
                        animation: "spin",
                        title: "Marcar como completado"
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        class: "play-icon",
                        name: "bi-check-circle",
                        scale: "2",
                        title: "Marcar como completado"
                      })),
                  _createTextVNode(" Completado ")
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 7,
                  onClick: handleDoNoCompleted,
                  class: "play-btn play-btn-selected"
                }, [
                  (completedLoading.value)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "play-icon",
                        name: "ri-loader-2-fill",
                        scale: "2",
                        animation: "spin",
                        title: "Eliminar de completados"
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        class: "play-icon",
                        name: "bi-check-circle-fill",
                        scale: "2",
                        title: "Eliminar de completados"
                      })),
                  _createTextVNode(" Completado ")
                ])),
            _createElementVNode("button", {
              class: "play-btn",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('goNext')))
            }, [
              _createVNode(_component_v_icon, {
                class: "play-icon",
                name: "bi-arrow-right-circle-fill",
                scale: "2",
                title: "Siguiente"
              }),
              _createTextVNode(" Siguiente")
            ])
          ])
        ]))
  ]))
}
}

})